import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { Mail, Lock, Facebook } from 'lucide-react';
import { FcGoogle } from 'react-icons/fc';

const DEMO_EMAIL = 'demo@wildasia.lk';
const DEMO_PASSWORD = 'demo1234';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (
      (email === 'oficer034@udawalawe.lk' && password === 'ict20079') ||
      (email === DEMO_EMAIL && password === DEMO_PASSWORD)
    ) {
      navigate('/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  const fillDemoCredentials = () => {
    setEmail(DEMO_EMAIL);
    setPassword(DEMO_PASSWORD);
    setError('');
  };

  return (
    <div className="login-wrapper">
      <video className="video-background" autoPlay loop muted>
        <source src="/login.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="login-overlay">
        <div className="login-box">
          <div className="login-header">
          <div className="login-logo">
            <img src="/icon.svg"  className="logo-icon" />
              <div className="logo-text">WildAsia</div>
          </div>

            <p className="login-subtitle">
              Wildlife Threats Monitoring with <br /> AI Enhanced Drone using IoT Sensors
            </p>
          </div>

          <h2 className="login-title">Login Portal</h2>
          <p className="login-desc">Please login into your account</p>

          <div className="demo-info">
            <p className="demo-info-title">Demo Login</p>
            <p className="demo-info-text">Email: {DEMO_EMAIL}</p>
            <p className="demo-info-text">Password: {DEMO_PASSWORD}</p>
            <button
              type="button"
              className="demo-fill-btn"
              onClick={fillDemoCredentials}
            >
              Use Demo Credentials
            </button>
          </div>

          {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="input-group">
              <Mail size={18} className="input-icon" />
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="input-group">
              <Lock size={18} className="input-icon" />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="remember">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">Keep me logged in</label>
            </div>

            <button className="login-btn" type="submit">Login</button>
          </form>

          <p className="or-text">or sign up with</p>

          <div className="social-buttons">
            <button className="google-btn"><FcGoogle size={20} /> Google</button>
            <button className="facebook-btn"><Facebook size={20} /> Facebook</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
